<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>内部管理</el-breadcrumb-item>
      <el-breadcrumb-item>微信商城</el-breadcrumb-item>
      <el-breadcrumb-item>订单管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.orderid" @keyup.enter.native="clicksearch" placeholder="请输入订单号"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.paystatus" placeholder="请选择" class="select">
              <el-option label="请选择支付状态" value="-1"></el-option>
              <el-option label="未支付" value="0"></el-option>
              <el-option label="已支付" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.wuliustatus" placeholder="请选择" class="select">
              <el-option label="请选择物流状态" value="-1"></el-option>
              <el-option label="待发货" value="0"></el-option>
              <el-option label="已发货" value="1"></el-option>
              <el-option label="已签收" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->
        <!-- 数据列表 start -->
        <el-table :data="dataList" border stripe>
          <el-table-column prop="Orderid" label="订单号"></el-table-column>
          <el-table-column prop="Body" label="商品名称"></el-table-column>
          <el-table-column prop="Jine" label="商品金额"></el-table-column>
          <el-table-column prop="Uuidgoodsname" label="商品分类"></el-table-column>
          <el-table-column prop="Recvname" label="收件人姓名"></el-table-column>
          <el-table-column prop="Recvphone" label="收件人手机"></el-table-column>
          <el-table-column prop="Recvaddress" label="收件人地址"></el-table-column>
          <el-table-column prop="Paystatusname" label="支付状态"></el-table-column>
          <el-table-column prop="Wuliustatusname" label="物流状态"></el-table-column>
          <el-table-column prop="Wuliuorderid" label="物流单号"></el-table-column>
          <el-table-column prop="Wuliuname" label="物流名称"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间"></el-table-column>
          <el-table-column prop="operation" label="操作" width="200px">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.Paystatus == 1 && scope.row.Wuliustatus == 0" @click="clickwuliu(scope.row)">发货</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->
        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

    <!-- 仓库发货弹出框 -->
    <el-dialog title="仓库发货" :visible.sync="wuliudialog" width="30%" :close-on-click-modal="false">
      <el-form :model="wuliuForm" ref="wuliuFormRef" label-width="70px">
        <el-form-item label="物流公司" class="addAdminForm">
          <el-input v-model="wuliuForm.wuliuname"></el-input>
        </el-form-item>
        <el-form-item label="物流单号" class="addAdminForm">
          <el-input v-model="wuliuForm.wuliuorderid"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clicksavewuliu">发货</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 仓库发货弹出框 end -->
  </el-tabs>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  name: 'MyWxStoreOrder',
  data () {
    return {
      activeName: 'first',
      // 查询
      keywords: {
        orderid: '',
        paystatus: '1',
        wuliustatus: '0'
      },
      dataList: [],
      dataListnum: 0,
      wuliudialog: false,
      wuliuForm: {
        id: '',
        wuliuname: '',
        wuliuorderid: ''
      },
      selectedPageNo: 1
    }
  },
  mounted () {
    this.apiGetWxstoreOrderNum()
    this.apiGetWxstoreOrderList()
  },
  methods: {
    clickwuliu (row) {
      this.wuliudialog = true
      this.wuliuForm.id = row.Id
      this.wuliuForm.wuliuname = ''
      this.wuliuForm.wuliuorderid = ''
    },
    clickreturn () {
      this.activeName = 'first'
    },
    clicksavewuliu () {
      if (!this.wuliuForm.wuliuname) {
        this.$alert('请输入物流公司', '提示')
        return
      }
      if (!this.wuliuForm.wuliuorderid) {
        this.$alert('请输入物流单号', '提示')
        return
      }
      this.apiFaHuoWxstoreOrder()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetWxstoreOrderNum()
      this.apiGetWxstoreOrderList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetWxstoreOrderList()
    },
    apiGetWxstoreOrderNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderid: that.keywords.orderid,
        paystatus: that.keywords.paystatus,
        wuliustatus: that.keywords.wuliustatus
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetWxstoreOrderNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetWxstoreOrderList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        orderid: that.keywords.orderid,
        paystatus: that.keywords.paystatus,
        wuliustatus: that.keywords.wuliustatus
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetWxstoreOrderList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiFaHuoWxstoreOrder: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: this.wuliuForm.id,
        wuliuname: this.wuliuForm.wuliuname,
        wuliuorderid: this.wuliuForm.wuliuorderid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_FaHuoWxstoreOrder, Qs.stringify(data))
        .then(function (response) {
          that.apiGetWxstoreOrderList()
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.wuliudialog = false
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
</style>
